import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { TIPO_ARTICULOS_OPTIONS } from "features/Inventario/constants/constants"
import { useTranslation } from "react-i18next"
import StatusMessage from "."

const TipoArticuloStatusMessage = ({
  tipoArticulo,
  outlined = true,
}: $TSMigrationFixMe) => {
  const { t } = useTranslation()
  const className = `g-status-message-${TIPO_ARTICULOS_OPTIONS(t)[
    tipoArticulo
  ].label.toLowerCase()} ${outlined ? "outlined" : ""}`
  return (
    <StatusMessage
      outlined={outlined}
      className={className}
    >
      {tipoArticulo === 1 ? (
        <FontAwesomeIcon
          // @ts-expect-error TS(2322): Type '{ icons: string[]; className: string; }' is ...
          icons={["fal", "bag-shopping"]}
          className='article-type-icon'
        />
      ) : (
        <FontAwesomeIcon
          // @ts-expect-error TS(2322): Type '{ icons: string[]; className: string; }' is ...
          icons={["fal", "gear"]}
          className='article-type-icon'
        />
      )}{" "}
      <span className='ml-1'>
        {TIPO_ARTICULOS_OPTIONS(t)[tipoArticulo].label}
      </span>
    </StatusMessage>
  )
}

export default TipoArticuloStatusMessage
